import { Component, HostListener } from '@angular/core';

interface MenuItem {
  label: string;
  url: string;
  children?: MenuItem[];
}

const RE3 = 'https://re3.fccenvironment.co.uk';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  /** Mirrors the #menu-main-menu items on https://re3.fccenvironment.co.uk */
  menu: MenuItem[] = [
    {
      label: 'Our Services',
      url: '#',
      children: [
        { label: 'Recycling Centres', url: `${RE3}/site-facilities/` },
        {
          label: 'Kerbside Recycling Collections',
          url: `${RE3}/recycling-collections/`,
        },
        { label: 'Recycling Banks', url: `${RE3}/recycling-banks/` },
        { label: 'Trade waste service', url: `${RE3}/trade-waste-service/` },
      ],
    },
    { label: 'News', url: `${RE3}/news/` },
    {
      label: 'Reduce, reuse, recycle',
      url: '#',
      children: [
        {
          label: 'Initiatives & campaigns',
          url: `${RE3}/our-initiatives/`,
        },
        { label: 'What to do with an item?', url: `${RE3}/recylo/` },
        {
          label: 'Education & Resources',
          url: `${RE3}/education-resources-2/`,
        },
      ],
    },
    {
      label: 'What happens to my waste?',
      url: '#',
      children: [
        { label: 'Material streams', url: `${RE3}/material-streams/` },
        {
          label: 'Annual Environmental Report',
          url: `${RE3}/annual-environmental-report/`,
        },
      ],
    },
    {
      label: 'About us',
      url: '#',
      children: [
        { label: 'About re3', url: `${RE3}/about-us/` },
        { label: 'About FCC', url: `${RE3}/about-fcc/` },
        {
          label: 'About Trade & Business Waste',
          url: `${RE3}/trade-business-waste/`,
        },
        {
          label: 'Accessibility statement',
          url: `${RE3}/accessibility-statement/`,
        },
      ],
    },
    { label: 'Contact us', url: `${RE3}/contact-us/` },
  ];

  /** Mobile nav / search drawers, and which top-level dropdown is showing. */
  menuOpen = false;
  searchOpen = false;
  openMenu: number | null = null;

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
    if (!this.menuOpen) {
      this.openMenu = null;
    }
  }

  toggleSearch(): void {
    this.searchOpen = !this.searchOpen;
  }

  /**
   * re3's theme opens a dropdown on the first click of a parent item and closes
   * it on the second; items without children navigate as normal.
   */
  onMenuClick(event: MouseEvent, index: number, item: MenuItem): void {
    if (!item.children?.length) {
      this.openMenu = null;
      return;
    }
    event.preventDefault();
    this.openMenu = this.openMenu === index ? null : index;
  }

  @HostListener('document:keydown.escape')
  closeAll(): void {
    this.openMenu = null;
    this.menuOpen = false;
    this.searchOpen = false;
  }
}
